module.exports = __webpack_public_path__ + "assets/img/carousel_5.4aae2529.png";